module.exports = __webpack_public_path__ + "static/media/icn-53-material.45f37ab0.svg";